export const headerfooter = {
  "title": "Add Headers & Footers",
  "titleUpdate": "Update Headers & Footers",
  "addMessage": "This file already contains a Header/Footer. Would you like to update the existing Header/Footer with the one you are adding? <br/> Note: If you choose to add another Header/Footer, it might overlap the existing one.",
  "removeMessage": "Do you want to delete the Header/Footer from document?",
  "removeNoneMessage": "Foxit PDF Editor can't find any Header/Footer in the document.",
  "emptyMessage": "The Header/Footer is empty, do you want to cancel this operation? Click \"OK\" to exit the Header/Footer dialog box, or click \"Cancel\" to continue with the current operations.",
  "leftHeaderText": "Left Header Text",
  "centerHeaderText": "Center Header Text",
  "rightHeaderText": "Right Header Text",
  "leftFooterText": "Left Footer Text",
  "centerFooterText": "Center Footer Text",
  "rightFooterText": "Right Footer Text",
  "top": "Top",
  "bottom": "Bottom",
  "left": "Left",
  "right": "Right",
  "appearanceOptionList": {
    "shrink": "Shrink document to avoid overwriting the document's text and graphics",
    "keep": "Keep position and size of header/footer text constant when printing on different page sizes"
  },
  "margin": "Margin(Inches): ",
  "font": "Font: ",
  "macros": "Macros: ",
  "macrosList": {
    "date": "Date",
    "fileName": "File Name",
    "pageNumber": "Page Number",
    "batesNumber": "Bates Number"
  },
  "insert": "Insert",
  "format": "Page number and date format",
  "embed": "Embed Font",
  "formatDlg": {
    "pageNumberFormat": "Page Number Format: ",
    "dateFormat": "Date Format: ",
    "startPage": "Start Page Nunmber: "
  },
  "color": "Color: ",
  "fontName": "Font Name",
  "fontSize": "Size",
  "Margin": "Margin (Inches)",
  "PreviewPage": "Preview Page",
  "PageRange": "Page Range Options",
  "pageRange": "Page Range",
  "allPages": "All Pages",
  "pageFrom": "Page From",
  "pageTo": "To",
  "insertPageNum": "Insert Page Number",
  "insertDate": "Insert Date",
  "add": "Add",
  "cancel": "Cancel",
  "options": {
    "fileName": "File Name",
    "page": "Page",
    "of": "of",
    "pageFormat": "1,1 of n,1/n,Page 1,Page 1 of n,Bates Number",
    "pageFormatShow": "%d,%d of %d,%d/%d,Page %d,Page %d of %d,Bates Number"
  }
}
